import { computed } from '@ember/object';
import FilterConstants from '../../../../filter-constants';
import BaseActualFilterAmplitude from '../../implementation-common/base-actual-filter-amplitude';
import * as CommonUtils from '../../../../utils/common';
import * as Complex from '../../../process-data/complex';

export default BaseActualFilterAmplitude.extend({
  whoAmI: 'app/models/implementation/first-order/common/actual-filter-amplitude.js',
  complexAlphaPlus: Complex.createComplex(0, 0),
  complexBetaPlus: Complex.createComplex(0, 0),
  complexRParallel: computed('r3', 'r4', 'opAmp', function () {
    var rOut = this.opAmp.rOut;
    var r3 = this.r3;
    var r4 = this.r4;
    var rParallel = CommonUtils.parallel(rOut, r3 + r4);
    var result = Complex.createComplex(rParallel, 0);
    return result;
  }),
  complexFF: Complex.createComplex(0, 0),
  complexAlphaMinus: Complex.createComplex(0, 0),
  complexBetaMinus: computed('r3', 'r4', 'sImaginary', function () {
    var sImaginary = this.sImaginary;
    var r3 = this.r3;
    var r4 = this.r4;
    var complexR3 = Complex.createComplex(r3, 0);
    var complexBetaDenom = Complex.createComplex(
      r3 + r4,
      r4 * r3 * FilterConstants.Limits.PARASITIC_INPUT_CAP * sImaginary,
    );
    var result = complexR3.divide(complexBetaDenom);
    return result;
  }),
  inputImpedance: computed('c1', 'r1', 'sImaginary', function () {
    var c1 = this.c1;
    var r1 = this.r1;
    var sImaginary = this.sImaginary;
    var result = Complex.createComplex(r1, -1 / (c1 * sImaginary));
    return result;
  }),
});
